import { defineNuxtPlugin } from '#app/nuxt'
import { LazySvgoCkbChoiceLogo, LazySvgoGoogleicon, LazySvgoInfo, LazySvgoPlay, LazySvgoTips, LazySvgoAdd, LazySvgoAnalysis, LazySvgoArrow, LazySvgoArrowup, LazySvgoBaby, LazySvgoBell, LazySvgoBook, LazySvgoBuy, LazySvgoCheck, LazySvgoChoiceLogo, LazySvgoCkb, LazySvgoClose1, LazySvgoClose, LazySvgoCorrect, LazySvgoDel, LazySvgoDelivery, LazySvgoError, LazySvgoFactory, LazySvgoFilter, LazySvgoHistory, LazySvgoHorn, LazySvgoInspection, LazySvgoLocal, LazySvgoLogo, LazySvgoMarketPlayIcon, LazySvgoMarketArrowRight, LazySvgoMarketIconCheck, LazySvgoMarketIconRight, LazySvgoMenu, LazySvgoNew, LazySvgoPartner1688, LazySvgoPartnerItachu, LazySvgoPartnerItsumo, LazySvgoPencil, LazySvgoPeoples, LazySvgoRobot, LazySvgoStarttime, LazySvgoUploadlogs, LazySvgoWorkBench, LazySvgoZaiku, LazySvgoZhifa, LazySvgo上传, LazySvgo关闭弹窗, LazySvgo创建, LazySvgo创建成功, LazySvgo勾, LazySvgo勾2, LazySvgo单向箭头, LazySvgo叉, LazySvgo商务舱, LazySvgo外链, LazySvgo头像, LazySvgo头等舱, LazySvgo左滑, LazySvgo成功, LazySvgo打勾, LazySvgo拍照, LazySvgo推广, LazySvgo提示, LazySvgo提示2, LazySvgo搜索, LazySvgo操作取消, LazySvgo放大, LazySvgo放大2, LazySvgo放大Active, LazySvgo更多, LazySvgo未登录头像, LazySvgo查看, LazySvgo检品标准, LazySvgo注册成功, LazySvgo照片, LazySvgo登录b2b, LazySvgo登录d2c, LazySvgo移除, LazySvgo筛选, LazySvgo箭头, LazySvgo经济舱, LazySvgo自动同步采购订单, LazySvgo菜单, LazySvgo解绑, LazySvgo计算, LazySvgo购物车, LazySvgo返回Return, LazySvgo进度条, LazySvgo选择要链接商品的SKU, LazySvgo选择要链接的商品, LazySvgo铂金舱, LazyIcon } from '#components'
const lazyGlobalComponents = [
  ["SvgoCkbChoiceLogo", LazySvgoCkbChoiceLogo],
["SvgoGoogleicon", LazySvgoGoogleicon],
["SvgoInfo", LazySvgoInfo],
["SvgoPlay", LazySvgoPlay],
["SvgoTips", LazySvgoTips],
["SvgoAdd", LazySvgoAdd],
["SvgoAnalysis", LazySvgoAnalysis],
["SvgoArrow", LazySvgoArrow],
["SvgoArrowup", LazySvgoArrowup],
["SvgoBaby", LazySvgoBaby],
["SvgoBell", LazySvgoBell],
["SvgoBook", LazySvgoBook],
["SvgoBuy", LazySvgoBuy],
["SvgoCheck", LazySvgoCheck],
["SvgoChoiceLogo", LazySvgoChoiceLogo],
["SvgoCkb", LazySvgoCkb],
["SvgoClose1", LazySvgoClose1],
["SvgoClose", LazySvgoClose],
["SvgoCorrect", LazySvgoCorrect],
["SvgoDel", LazySvgoDel],
["SvgoDelivery", LazySvgoDelivery],
["SvgoError", LazySvgoError],
["SvgoFactory", LazySvgoFactory],
["SvgoFilter", LazySvgoFilter],
["SvgoHistory", LazySvgoHistory],
["SvgoHorn", LazySvgoHorn],
["SvgoInspection", LazySvgoInspection],
["SvgoLocal", LazySvgoLocal],
["SvgoLogo", LazySvgoLogo],
["SvgoMarketPlayIcon", LazySvgoMarketPlayIcon],
["SvgoMarketArrowRight", LazySvgoMarketArrowRight],
["SvgoMarketIconCheck", LazySvgoMarketIconCheck],
["SvgoMarketIconRight", LazySvgoMarketIconRight],
["SvgoMenu", LazySvgoMenu],
["SvgoNew", LazySvgoNew],
["SvgoPartner1688", LazySvgoPartner1688],
["SvgoPartnerItachu", LazySvgoPartnerItachu],
["SvgoPartnerItsumo", LazySvgoPartnerItsumo],
["SvgoPencil", LazySvgoPencil],
["SvgoPeoples", LazySvgoPeoples],
["SvgoRobot", LazySvgoRobot],
["SvgoStarttime", LazySvgoStarttime],
["SvgoUploadlogs", LazySvgoUploadlogs],
["SvgoWorkBench", LazySvgoWorkBench],
["SvgoZaiku", LazySvgoZaiku],
["SvgoZhifa", LazySvgoZhifa],
["Svgo上传", LazySvgo上传],
["Svgo关闭弹窗", LazySvgo关闭弹窗],
["Svgo创建", LazySvgo创建],
["Svgo创建成功", LazySvgo创建成功],
["Svgo勾", LazySvgo勾],
["Svgo勾2", LazySvgo勾2],
["Svgo单向箭头", LazySvgo单向箭头],
["Svgo叉", LazySvgo叉],
["Svgo商务舱", LazySvgo商务舱],
["Svgo外链", LazySvgo外链],
["Svgo头像", LazySvgo头像],
["Svgo头等舱", LazySvgo头等舱],
["Svgo左滑", LazySvgo左滑],
["Svgo成功", LazySvgo成功],
["Svgo打勾", LazySvgo打勾],
["Svgo拍照", LazySvgo拍照],
["Svgo推广", LazySvgo推广],
["Svgo提示", LazySvgo提示],
["Svgo提示2", LazySvgo提示2],
["Svgo搜索", LazySvgo搜索],
["Svgo操作取消", LazySvgo操作取消],
["Svgo放大", LazySvgo放大],
["Svgo放大2", LazySvgo放大2],
["Svgo放大Active", LazySvgo放大Active],
["Svgo更多", LazySvgo更多],
["Svgo未登录头像", LazySvgo未登录头像],
["Svgo查看", LazySvgo查看],
["Svgo检品标准", LazySvgo检品标准],
["Svgo注册成功", LazySvgo注册成功],
["Svgo照片", LazySvgo照片],
["Svgo登录b2b", LazySvgo登录b2b],
["Svgo登录d2c", LazySvgo登录d2c],
["Svgo移除", LazySvgo移除],
["Svgo筛选", LazySvgo筛选],
["Svgo箭头", LazySvgo箭头],
["Svgo经济舱", LazySvgo经济舱],
["Svgo自动同步采购订单", LazySvgo自动同步采购订单],
["Svgo菜单", LazySvgo菜单],
["Svgo解绑", LazySvgo解绑],
["Svgo计算", LazySvgo计算],
["Svgo购物车", LazySvgo购物车],
["Svgo返回Return", LazySvgo返回Return],
["Svgo进度条", LazySvgo进度条],
["Svgo选择要链接商品的SKU", LazySvgo选择要链接商品的SKU],
["Svgo选择要链接的商品", LazySvgo选择要链接的商品],
["Svgo铂金舱", LazySvgo铂金舱],
["Icon", LazyIcon],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
